<template>
  <div v-if="show" id="modal-cookies" class="px-8 py-3 flex flex-column align-center">
    <div class="flex align-center" style="max-width: 1000px;">
      <div class="flex align-center">
        <!-- <span>Ketterä uses browser cookies to give you the best possible experience. To use Ketterä, you must agree to our
          <strong>privacy policy</strong>, including <strong>cookie policy</strong>.
        </span> -->
        <p>
          <span class="flex-1 mr-2">Tämä sivusto hyödyntää evästeitä (cookies) käyttäjäistunnon ylläpitämiseksi.</span>
          <span @click.prevent="privacyPolicy = !privacyPolicy" class="i-flex align-center pointer">
            <strong>NÄYTÄ LISÄÄ</strong>
            <i class="material-icons">arrow_drop_down</i>
          </span>
        </p>
      </div>
      <!-- <a href="#" @click.prevent="privacyPolicy = !privacyPolicy" class="color-black txt-bold">Privacy Policy</a> -->
      <button @click.prevent="proceed" class="flex-shrink-0 btn btn-empty btn-1- ml-5">Hyväksyn</button>
      <br>
    </div>
    <div v-if="privacyPolicy" class="mt-4" style="max-width: 1000px;">
      <hr class="mb-4">
      <!-- <p class="px-10">tähän tulee Privacy Policy...</p> -->
      <p class="px-6 pb-6">
        <strong>Evästeet</strong>
        <br>
        Sivustolla käytetään evästeitä käyttäjäistunnon ylläpitämiseksi. Teknisiin evästeisiin ei kerätä eikä tallenneta käyttäjän yksilöiviä henkilötietoja.
        <br>
        Käyttäjällä on mahdollisuus estää evästeiden käyttö muuttamalla selaimensa asetuksia. Sovelluksen käyttäminen ilman evästeitä saattaa kuitenkin vaikuttaa sen toiminnallisuuteen.
        <br><br>
        <strong>Tietojen kerääminen</strong>
        <br>
        Sovellus ei kerää käyttäjää yksilöiviä henkilötietoja. Tietoja käyttäjistä voidaan kuitenkin kerätä sivuston kävijätilastointia sekä sivujen sisältöä ja käytettävyyden kehittämistä varten. Tämä tarkoittaa mahdollisuutta kerätä tietoa esimerkiksi sivuston käytöstä, sivustolla vierailevien päätelaitteista ja selaimista verkkoanalytiikan avulla. Mikäli näitä tietoja kerätään, ne anonymisoidaan, joten niitä ei voi liittää yksittäiseen henkilöön.
        <br><br>
        <strong>Karttapalvelu ja linkit muille sivustoille</strong>
        <br>
        Sovellukseen on liitetty upotuksia Googlen karttapalveluun. Lisäksi sovellus sisältää linkkejä muille sivustoille. Näiden tietosuojaa ja evästeitä koskevat käytännöt ovat karttapalvelun tarjoajan ja kyseisten sivustojen ylläpitäjien vastuulla ja ne voivat poiketa tämän sovelluksen käytännöistä.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: true,
      privacyPolicy: false
    }
  },

  methods: {
    proceed () {
      this.show = false
      this.$cookie.set('session', 'terms agreed!', 1)
    }
  },

  created () {
    // this.$cookie.delete('session')
    if (this.$cookie.get('session')) {
      this.show = false
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#modal-cookies {
  z-index: 9999;
  position: fixed;
  top: $Tbar-height;
  left: 0;
  //left: 50%;
  //transform: translateX(-50%);
  width: 100%;
  //width: calc(100% - (2 * 16px));
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgb(210, 210, 210);
  //border-bottom-left-radius: 3px;
  //border-bottom-right-radius: 3px;
  box-shadow: 0 1.5px 4px rgba(0, 0, 0, 0.1);
  font-size: 0.8rem;
  hr {
    border: 0;
    border-top: 1px solid rgb(210, 210, 210);
  }
  button {
    color:black;
    border: 1px solid black;
  }
}
</style>
